// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"06ed3d90","78":"45edb88f","219":"c0dba3ac","360":"f40ea91b","508":"06ed3d90","594":"0c05f42f","618":"a76905f6","758":"812999c4"}[chunkId] + ".chunk.css";
};